import resourcesNavMeta from "@/data/resources-nav-meta.json";
import type { NavResourceKey } from "@/lib/cc-nav-resources";

type ResourceNavMetaEntry = {
  published: boolean;
};

const meta = resourcesNavMeta as Record<NavResourceKey, ResourceNavMetaEntry>;

/** Whether a top-level resource hub (footer + mega column header) is live. */
export function isResourceHubPublished(key: NavResourceKey): boolean {
  return meta[key]?.published ?? false;
}
